import { getRelativeBasePath } from '@atlassian/help-center-common-util/history';

export const getPortalSettingsBaseRoute = () => `${getRelativeBasePath()}/portal/customize/sidebar`;

export const getPortalSettingsRequestGroupDetailRoute = (requestGroupId: number) =>
	`${getPortalSettingsBaseRoute()}/request-groups/${requestGroupId}`;
export const getPortalSettingsRequestTypeDetailRoute = (
	requestGroupId: number,
	requestTypeId: number,
) =>
	`${getPortalSettingsBaseRoute()}/request-groups/${requestGroupId}/request-types/${requestTypeId}`;
export const getPortalSettingsRequestTypeDetailOrphanRoute = (requestTypeId: number) =>
	`${getPortalSettingsBaseRoute()}/request-types/${requestTypeId}`;

export const getExperienceLocation = (experience?: string) => {
	switch (experience) {
		case 'add-announcement':
			return `${getPortalSettingsBaseRoute()}/add-announcement`;
		case 'request-groups':
			return `${getPortalSettingsBaseRoute()}/request-groups`;
		default:
			return undefined; // removing home page from the sidebar, since no entry point with new experience
	}
};

export { SidebarHeader } from './styled';
